import { ShoppingCart, Plus, Eye, EyeOff, Edit3, Trash2 } from "lucide-react";
import { Button } from "../ui/button";

export function CategoriesSection({
  categories,
  showInactive,
  onToggleShowInactive,
  onAddCategory,
  onEditCategory,
  onToggleActive,
  onDeleteCategory,
}) {
  return (
    <div className="card-base p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-white font-['Outfit'] flex items-center gap-2">
          <ShoppingCart size={20} className="text-amber-400" />
          Shopping Categories
        </h2>
        <div className="flex items-center gap-2">
          <button
            onClick={onToggleShowInactive}
            className={`p-2 rounded-lg transition-colors ${
              showInactive
                ? "bg-slate-700 text-white"
                : "text-slate-400 hover:text-white"
            }`}
            title={showInactive ? "Hide inactive" : "Show inactive"}
            data-testid="toggle-inactive-categories"
          >
            {showInactive ? <Eye size={18} /> : <EyeOff size={18} />}
          </button>
          <Button
            size="sm"
            onClick={onAddCategory}
            className="bg-amber-600 hover:bg-amber-500"
            data-testid="add-category-button"
          >
            <Plus size={16} className="mr-1" />
            Add
          </Button>
        </div>
      </div>

      <div className="space-y-2">
        {categories.length === 0 ? (
          <p className="text-slate-500 text-center py-4">No categories found</p>
        ) : (
          categories.map((category) => (
            <div
              key={category.id}
              className={`flex items-center gap-3 p-3 rounded-xl transition-colors ${
                category.active
                  ? "bg-slate-800/50 hover:bg-slate-800"
                  : "bg-slate-800/20 opacity-60"
              }`}
              data-testid={`category-item-${category.id}`}
            >
              <div
                className="w-4 h-4 rounded-full flex-shrink-0"
                style={{ backgroundColor: category.color }}
              />
              <span
                className={`flex-1 ${
                  category.active ? "text-white" : "text-slate-500 line-through"
                }`}
              >
                {category.name}
              </span>
              {!category.active && (
                <span className="text-xs text-slate-500 px-2 py-0.5 rounded bg-slate-700">
                  Inactive
                </span>
              )}
              <div className="flex items-center gap-1">
                <button
                  onClick={() => onToggleActive(category)}
                  className={`p-1.5 rounded-lg transition-colors ${
                    category.active
                      ? "text-slate-400 hover:text-amber-400 hover:bg-slate-700"
                      : "text-emerald-400 hover:bg-slate-700"
                  }`}
                  title={category.active ? "Deactivate" : "Reactivate"}
                  data-testid={`toggle-category-${category.id}`}
                >
                  {category.active ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
                <button
                  onClick={() => onEditCategory(category)}
                  className="p-1.5 text-slate-400 hover:text-white hover:bg-slate-700 rounded-lg transition-colors"
                  data-testid={`edit-category-${category.id}`}
                >
                  <Edit3 size={16} />
                </button>
                <button
                  onClick={() => onDeleteCategory(category)}
                  className="p-1.5 text-slate-400 hover:text-red-400 hover:bg-slate-700 rounded-lg transition-colors"
                  data-testid={`delete-category-${category.id}`}
                >
                  <Trash2 size={16} />
                </button>
              </div>
            </div>
          ))
        )}
      </div>
      <p className="text-xs text-slate-500 mt-3">
        Categories with existing items will be deactivated instead of deleted.
      </p>
    </div>
  );
}
